import React from "react";

export default ({ fill, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 217.17 62.19"
    fill={fill}
    width={width}
    height={height}
  >
    <g id="Layer_1">
      <g>
        <path
          className="st0"
          d="M49.21,60.44V27.11l5.83-3.89v33.32L49.21,60.44z M36.31,60.44V4.8l5.83-3.89v55.65L36.31,60.44z
			 M23.38,60.44V15.67l5.83-3.89v44.78L23.38,60.44z M10.26,60.44v-33.4l5.83-3.89v33.4L10.26,60.44z M10.43,22.88h4.94l-5.51,3.68
			H4.91L10.43,22.88z M23.55,11.51h4.94l-5.51,3.68h-4.94L23.55,11.51z M36.47,0.63h4.94L35.9,4.31h-4.94L36.47,0.63z M49.37,22.95
			h4.94l-5.51,3.68h-4.94L49.37,22.95z M55.66,22.58c0-0.01,0-0.03,0-0.04c0-0.01-0.02-0.02-0.02-0.03
			c-0.02-0.04-0.04-0.07-0.07-0.1c-0.02-0.02-0.03-0.03-0.05-0.04c-0.01-0.01-0.01-0.01-0.02-0.02c-0.04-0.02-0.07-0.02-0.11-0.03
			c-0.01,0-0.02-0.01-0.03-0.01h-6.08c-0.06,0-0.12,0.02-0.18,0.05l-6.32,4.22V0.32c0-0.02-0.01-0.04-0.02-0.05
			c0-0.01,0.01-0.03,0-0.04c0-0.01-0.01-0.02-0.02-0.03c-0.02-0.04-0.04-0.07-0.07-0.1c-0.02-0.02-0.03-0.03-0.05-0.04
			c-0.01,0-0.01-0.01-0.02-0.02c-0.04-0.02-0.08-0.02-0.11-0.03C42.48,0.01,42.47,0,42.46,0h-6.08c-0.06,0-0.12,0.02-0.17,0.05
			l-6.46,4.31c-0.04,0.02-0.05,0.06-0.08,0.1h-0.13v6.41h-6.08c-0.06,0-0.12,0.02-0.18,0.05l-6.46,4.31
			c-0.12,0.08-0.17,0.22-0.13,0.36c0,0.01,0.02,0.02,0.02,0.03h-0.1v6.69c-0.01-0.01-0.02-0.01-0.02-0.01
			c-0.01,0-0.01-0.01-0.02-0.02c-0.04-0.02-0.08-0.02-0.12-0.03c-0.01,0-0.02-0.01-0.03-0.01h-6.08c-0.06,0-0.12,0.02-0.18,0.05
			l-6.46,4.31c-0.09,0.06-0.12,0.16-0.12,0.26H3.55v34.47H9.9c0.01,0,0.03,0.01,0.04,0.01c0.01,0,0.02-0.01,0.04-0.01h0.03v-0.01
			c0.04-0.01,0.08-0.01,0.11-0.03l6.46-4.31c0.01,0,0.01-0.01,0.02-0.02v4.37h6.41c0.02,0,0.04,0.01,0.05,0.01
			c0.06,0,0.12-0.02,0.17-0.05l6.29-4.19v4.23h6.42c0.02,0,0.03,0.01,0.05,0.01c0.06,0,0.12-0.02,0.17-0.05l6.29-4.19v4.23h6.42
			c0.01,0,0.01,0,0.02,0c0,0,0.01,0,0.01,0h0.02v0c0.05-0.01,0.1-0.02,0.14-0.04l6.46-4.31c0.09-0.06,0.14-0.16,0.14-0.26V22.63
			C55.67,22.62,55.66,22.6,55.66,22.58"
        ></path>
        <path
          className="st0"
          d="M69.49,29.82c0.54,0,1.02,0.09,1.44,0.26c0.42,0.17,0.77,0.42,1.06,0.72c0.28,0.31,0.5,0.66,0.65,1.07
			c0.15,0.41,0.22,0.84,0.22,1.31c0,0.47-0.07,0.9-0.22,1.31c-0.15,0.41-0.37,0.77-0.65,1.07c-0.29,0.31-0.64,0.55-1.06,0.72
			c-0.42,0.17-0.9,0.26-1.44,0.26H65.1c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.08-0.13-0.18-0.13-0.3V25.87c0-0.12,0.04-0.22,0.13-0.3
			c0.08-0.09,0.18-0.13,0.3-0.13h6.63c0.12,0,0.21,0.04,0.29,0.13c0.08,0.09,0.12,0.18,0.12,0.3v0.57c0,0.12-0.04,0.22-0.12,0.3
			c-0.08,0.09-0.18,0.13-0.29,0.13h-5.55v2.95H69.49z M71.34,33.19c0-0.26-0.04-0.51-0.13-0.75c-0.09-0.24-0.22-0.44-0.4-0.62
			c-0.18-0.17-0.39-0.31-0.65-0.41c-0.26-0.1-0.56-0.15-0.91-0.15h-3.08v3.87h3.08c0.35,0,0.65-0.05,0.91-0.15
			c0.26-0.1,0.47-0.24,0.65-0.41c0.17-0.17,0.31-0.38,0.4-0.62C71.3,33.7,71.34,33.45,71.34,33.19"
        ></path>
        <path
          className="st0"
          d="M81.04,36.55c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.09-0.13-0.19-0.13-0.3v-5.31l-4.61,5.57
			c-0.09,0.12-0.2,0.17-0.35,0.17H75.1c-0.12,0-0.21-0.04-0.29-0.13c-0.08-0.09-0.12-0.19-0.12-0.3v-7.39c0-0.11,0.04-0.22,0.13-0.3
			s0.19-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13c0.09,0.09,0.13,0.19,0.13,0.3v5.36l4.61-5.61c0.05-0.05,0.1-0.1,0.15-0.13
			c0.05-0.03,0.11-0.05,0.2-0.05h0.52c0.12,0,0.22,0.04,0.3,0.13c0.08,0.09,0.13,0.19,0.13,0.3v7.39c0,0.12-0.04,0.22-0.13,0.3
			c-0.09,0.08-0.19,0.13-0.3,0.13H81.04z"
        ></path>
        <path
          className="st0"
          d="M89.35,25.4c0,0.37-0.08,0.71-0.25,1.02c-0.16,0.31-0.37,0.61-0.62,0.9c-0.25,0.29-0.52,0.59-0.82,0.89
			c-0.3,0.3-0.6,0.63-0.88,0.99c0.26-0.06,0.55-0.09,0.87-0.09c0.53,0,1.01,0.09,1.46,0.25c0.44,0.17,0.83,0.42,1.15,0.74
			c0.32,0.33,0.57,0.73,0.75,1.2c0.18,0.47,0.27,1.01,0.27,1.61c0,0.56-0.09,1.08-0.27,1.55c-0.18,0.47-0.43,0.87-0.75,1.21
			c-0.32,0.33-0.71,0.59-1.15,0.78c-0.45,0.18-0.93,0.28-1.46,0.28c-0.53,0-1.01-0.09-1.46-0.28c-0.45-0.19-0.83-0.44-1.15-0.78
			c-0.32-0.33-0.57-0.74-0.75-1.21c-0.18-0.47-0.27-0.99-0.27-1.55c0-0.81,0.09-1.53,0.28-2.13c0.19-0.61,0.43-1.14,0.72-1.59
			c0.29-0.45,0.6-0.85,0.94-1.19c0.34-0.34,0.65-0.65,0.94-0.94c0.29-0.28,0.53-0.56,0.72-0.82c0.19-0.26,0.28-0.54,0.28-0.83
			c0-0.12,0.04-0.22,0.13-0.3c0.08-0.09,0.18-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13C89.31,25.18,89.35,25.28,89.35,25.4
			 M87.65,30.46c-0.74,0-1.29,0.22-1.65,0.67c-0.36,0.45-0.54,1.04-0.54,1.77c0,0.73,0.18,1.32,0.54,1.77
			c0.36,0.45,0.91,0.67,1.65,0.67c0.74,0,1.29-0.22,1.65-0.67c0.36-0.45,0.54-1.04,0.54-1.77c0-0.73-0.18-1.32-0.54-1.77
			C88.94,30.68,88.39,30.46,87.65,30.46"
        ></path>
        <path
          className="st0"
          d="M94.12,28.43c0.08-0.09,0.18-0.13,0.3-0.13h5.35c0.12,0,0.22,0.04,0.3,0.13c0.08,0.09,0.13,0.18,0.13,0.3
			v7.39c0,0.12-0.04,0.22-0.13,0.3c-0.09,0.09-0.18,0.13-0.3,0.13h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.08-0.13-0.19-0.13-0.3
			v-6.46h-3.32v4.14c0,0.43-0.04,0.83-0.13,1.18c-0.09,0.36-0.24,0.66-0.44,0.91c-0.21,0.25-0.48,0.45-0.82,0.6
			c-0.34,0.14-0.76,0.21-1.25,0.21H92.6c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.08-0.13-0.18-0.13-0.3v-0.51c0-0.12,0.04-0.22,0.13-0.3
			c0.08-0.09,0.18-0.13,0.3-0.13h0.19c0.49,0,0.81-0.14,0.97-0.42c0.16-0.28,0.24-0.66,0.24-1.13v-5.06
			C94,28.61,94.04,28.51,94.12,28.43"
        ></path>
        <path
          className="st0"
          d="M108.92,36.55c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.19-0.13-0.3v-5.31l-4.61,5.57
			c-0.09,0.12-0.2,0.17-0.35,0.17h-0.54c-0.12,0-0.21-0.04-0.29-0.13c-0.08-0.09-0.12-0.19-0.12-0.3v-7.39
			c0-0.11,0.04-0.22,0.13-0.3c0.09-0.09,0.19-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13c0.09,0.09,0.13,0.19,0.13,0.3v5.36
			l4.62-5.61c0.05-0.05,0.1-0.1,0.15-0.13c0.05-0.03,0.11-0.05,0.2-0.05h0.52c0.11,0,0.22,0.04,0.3,0.13
			c0.08,0.09,0.13,0.19,0.13,0.3v7.39c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.08-0.19,0.13-0.3,0.13H108.92z"
        ></path>
        <path
          className="st0"
          d="M115.69,28.14c0.57,0,1.08,0.09,1.52,0.26c0.44,0.17,0.82,0.42,1.14,0.72c0.32,0.31,0.57,0.68,0.75,1.12
			c0.19,0.44,0.3,0.92,0.34,1.44c0.01,0.09,0.02,0.21,0.02,0.34v0.41v0.41c0,0.13-0.01,0.24-0.02,0.32
			c-0.05,0.53-0.17,1.01-0.35,1.44c-0.18,0.43-0.43,0.8-0.74,1.11c-0.32,0.31-0.7,0.55-1.14,0.72c-0.45,0.17-0.95,0.26-1.52,0.26
			c-0.57,0-1.08-0.09-1.52-0.26c-0.44-0.17-0.82-0.42-1.14-0.72c-0.32-0.31-0.57-0.68-0.75-1.11c-0.19-0.43-0.3-0.92-0.34-1.44
			c-0.01-0.09-0.02-0.19-0.02-0.32c-0.01-0.13-0.01-0.27-0.01-0.41c0-0.14,0-0.28,0.01-0.41c0.01-0.13,0.01-0.25,0.02-0.34
			c0.04-0.52,0.15-1,0.34-1.44c0.19-0.44,0.44-0.81,0.75-1.12c0.32-0.31,0.7-0.55,1.14-0.72C114.62,28.23,115.12,28.14,115.69,28.14
			 M118.01,33.09c0.02-0.18,0.03-0.4,0.03-0.66c0-0.26-0.01-0.48-0.03-0.67c-0.03-0.32-0.1-0.61-0.21-0.89
			c-0.11-0.27-0.25-0.51-0.44-0.71c-0.19-0.2-0.42-0.36-0.7-0.48c-0.27-0.12-0.6-0.17-0.97-0.17c-0.37,0-0.69,0.06-0.97,0.17
			c-0.28,0.12-0.51,0.28-0.7,0.48c-0.19,0.2-0.34,0.44-0.44,0.71c-0.11,0.28-0.17,0.57-0.21,0.89c-0.02,0.19-0.03,0.41-0.03,0.67
			c0,0.26,0.01,0.48,0.03,0.66c0.03,0.32,0.1,0.61,0.21,0.89c0.11,0.27,0.25,0.51,0.44,0.71c0.19,0.2,0.42,0.36,0.7,0.48
			c0.28,0.12,0.6,0.17,0.97,0.17c0.37,0,0.69-0.06,0.97-0.17c0.28-0.12,0.51-0.28,0.7-0.48c0.19-0.2,0.34-0.44,0.44-0.71
			C117.91,33.7,117.98,33.41,118.01,33.09"
        ></path>
        <path
          className="st0"
          d="M127.69,28.3c0.12,0,0.22,0.04,0.3,0.13c0.09,0.08,0.13,0.19,0.13,0.3v0.51c0,0.12-0.04,0.22-0.13,0.3
			c-0.08,0.09-0.18,0.13-0.3,0.13h-2.74v6.46c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.09-0.18,0.13-0.3,0.13h-0.59
			c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.18-0.13-0.3v-6.46h-2.74c-0.12,0-0.22-0.04-0.3-0.13
			c-0.08-0.08-0.13-0.19-0.13-0.3v-0.51c0-0.12,0.04-0.22,0.13-0.3c0.08-0.09,0.18-0.13,0.3-0.13H127.69z"
        ></path>
        <path
          className="st0"
          d="M128.97,31.63c0.04-0.49,0.16-0.94,0.35-1.36c0.19-0.42,0.44-0.79,0.74-1.11c0.31-0.32,0.68-0.57,1.1-0.75
			c0.43-0.18,0.91-0.27,1.43-0.27c0.57,0,1.08,0.09,1.53,0.28c0.45,0.18,0.83,0.45,1.15,0.8c0.32,0.35,0.56,0.77,0.73,1.27
			c0.17,0.5,0.25,1.05,0.25,1.67v0.43c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.09-0.18,0.13-0.3,0.13h-5.46v0.09
			c0.02,0.72,0.24,1.27,0.66,1.66c0.42,0.38,0.94,0.58,1.56,0.58c0.58,0,1.02-0.08,1.31-0.25c0.29-0.16,0.53-0.35,0.71-0.55
			c0.08-0.08,0.16-0.14,0.22-0.17c0.06-0.03,0.16-0.05,0.29-0.05h0.47c0.12,0,0.22,0.04,0.32,0.13c0.1,0.08,0.13,0.19,0.11,0.3
			c-0.03,0.19-0.12,0.4-0.27,0.63c-0.15,0.23-0.36,0.44-0.64,0.63c-0.28,0.2-0.63,0.36-1.05,0.49c-0.42,0.13-0.91,0.2-1.47,0.2
			c-0.53,0-1-0.09-1.43-0.28c-0.42-0.19-0.79-0.44-1.1-0.76c-0.31-0.32-0.56-0.7-0.75-1.14c-0.19-0.44-0.31-0.92-0.35-1.44
			C128.92,32.6,128.92,32.12,128.97,31.63 M130.38,31.68h4.46v-0.05c0-0.64-0.2-1.16-0.61-1.55c-0.41-0.39-0.95-0.58-1.63-0.58
			c-0.31,0-0.59,0.05-0.86,0.15c-0.26,0.1-0.5,0.24-0.7,0.43c-0.2,0.19-0.36,0.41-0.47,0.67c-0.12,0.27-0.18,0.55-0.19,0.87V31.68z"
        ></path>
        <path
          className="st0"
          d="M139.63,31.47l3.3-2.9c0.06-0.05,0.14-0.11,0.25-0.17c0.1-0.06,0.22-0.1,0.37-0.1h0.76
			c0.11,0,0.2,0.04,0.27,0.11c0.07,0.07,0.11,0.16,0.11,0.27c0,0.05-0.01,0.1-0.02,0.15c-0.02,0.05-0.06,0.1-0.15,0.17l-3.84,3.36
			l4.22,3.51c0.11,0.08,0.16,0.18,0.16,0.3c0,0.11-0.04,0.2-0.11,0.27c-0.08,0.07-0.16,0.11-0.27,0.11h-0.83
			c-0.16,0-0.29-0.03-0.4-0.09c-0.11-0.06-0.19-0.12-0.25-0.17l-3.57-2.97v2.81c0,0.12-0.04,0.21-0.13,0.3
			c-0.09,0.08-0.19,0.13-0.3,0.13h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.18-0.13-0.3v-7.39c0-0.12,0.04-0.22,0.13-0.3
			c0.08-0.08,0.19-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13c0.08,0.09,0.13,0.19,0.13,0.3V31.47z"
        ></path>
        <path
          className="st0"
          d="M145.75,34.47c0-0.42,0.08-0.79,0.25-1.11c0.17-0.32,0.4-0.59,0.7-0.81c0.3-0.22,0.64-0.4,1.04-0.54
			c0.4-0.14,0.82-0.24,1.26-0.32l2.24-0.36v-0.21c0-0.54-0.18-0.94-0.53-1.21c-0.36-0.27-0.8-0.4-1.33-0.4
			c-0.47,0-0.82,0.09-1.05,0.26c-0.24,0.17-0.44,0.37-0.61,0.6c-0.06,0.09-0.13,0.14-0.2,0.17c-0.08,0.03-0.18,0.05-0.3,0.05h-0.48
			c-0.12,0-0.22-0.04-0.31-0.13c-0.09-0.09-0.13-0.19-0.12-0.3c0.02-0.23,0.11-0.47,0.28-0.71c0.17-0.24,0.39-0.46,0.67-0.65
			c0.28-0.19,0.6-0.35,0.97-0.47c0.37-0.12,0.75-0.18,1.17-0.18c0.48,0,0.92,0.07,1.33,0.21c0.41,0.14,0.76,0.34,1.05,0.6
			c0.29,0.26,0.52,0.59,0.68,0.98c0.17,0.39,0.25,0.84,0.25,1.35v4.84c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.08-0.18,0.13-0.3,0.13
			h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.19-0.13-0.3v-0.65c-0.1,0.2-0.24,0.38-0.44,0.53
			c-0.2,0.15-0.43,0.28-0.69,0.39c-0.26,0.11-0.53,0.19-0.81,0.24c-0.28,0.05-0.54,0.08-0.79,0.08c-0.41,0-0.79-0.06-1.13-0.17
			c-0.34-0.12-0.63-0.27-0.87-0.47c-0.24-0.19-0.43-0.43-0.56-0.71C145.82,35.08,145.75,34.79,145.75,34.47 M148.67,35.34
			c0.38,0,0.73-0.06,1.05-0.17c0.32-0.12,0.59-0.28,0.82-0.48c0.23-0.21,0.4-0.45,0.52-0.74c0.12-0.29,0.18-0.6,0.18-0.95v-0.4
			l-1.87,0.3c-0.67,0.11-1.2,0.27-1.59,0.51c-0.39,0.23-0.59,0.53-0.59,0.9c0,0.12,0.02,0.23,0.08,0.35
			c0.05,0.12,0.14,0.23,0.25,0.33c0.12,0.11,0.27,0.19,0.45,0.25C148.16,35.31,148.4,35.34,148.67,35.34"
        ></path>
        <path
          className="st0"
          d="M70.84,55.58c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.09-0.13-0.19-0.13-0.3v-5.31l-4.62,5.57
			c-0.09,0.12-0.2,0.17-0.35,0.17h-0.54c-0.12,0-0.21-0.04-0.29-0.13c-0.08-0.09-0.12-0.19-0.12-0.3v-7.39
			c0-0.11,0.04-0.22,0.13-0.3c0.09-0.09,0.19-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13c0.09,0.08,0.13,0.19,0.13,0.3v5.36
			l4.61-5.62c0.05-0.05,0.1-0.09,0.15-0.13c0.05-0.03,0.11-0.05,0.2-0.05h0.52c0.12,0,0.22,0.04,0.3,0.13
			c0.08,0.08,0.13,0.19,0.13,0.3v7.39c0,0.12-0.04,0.22-0.13,0.3c-0.09,0.08-0.19,0.13-0.3,0.13H70.84z"
        ></path>
        <path
          className="st0"
          d="M78.29,52.41l2.52-4.76c0.03-0.06,0.09-0.13,0.18-0.21c0.09-0.07,0.23-0.11,0.4-0.11h0.52
			c0.12,0,0.22,0.04,0.3,0.13c0.08,0.08,0.13,0.19,0.13,0.3v7.39c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.08-0.19,0.13-0.3,0.13h-0.59
			c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.09-0.13-0.19-0.13-0.3v-4.77l-1.87,3.46c-0.05,0.1-0.12,0.19-0.2,0.27s-0.2,0.13-0.36,0.13
			H78.1c-0.16,0-0.28-0.04-0.36-0.13c-0.08-0.09-0.15-0.17-0.2-0.27l-1.87-3.46v4.77c0,0.12-0.04,0.22-0.13,0.3
			c-0.09,0.08-0.19,0.13-0.3,0.13h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.09-0.13-0.19-0.13-0.3v-7.39c0-0.12,0.04-0.22,0.13-0.3
			c0.08-0.09,0.19-0.13,0.3-0.13h0.52c0.18,0,0.32,0.04,0.4,0.11c0.09,0.07,0.15,0.14,0.18,0.21L78.29,52.41z"
        ></path>
        <path
          className="st0"
          d="M86.03,53.66c0.12,0,0.22,0.04,0.3,0.13c0.08,0.08,0.13,0.19,0.13,0.3v1.06c0,0.11-0.04,0.21-0.13,0.3
			c-0.08,0.08-0.18,0.13-0.3,0.13h-1.06c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.19-0.13-0.3v-1.06c0-0.12,0.04-0.22,0.13-0.3
			c0.09-0.08,0.18-0.13,0.3-0.13H86.03z"
        ></path>
        <path
          className="st0"
          d="M100.86,44.48c0.12,0,0.22,0.04,0.3,0.13c0.09,0.08,0.13,0.19,0.13,0.3v10.25c0,0.12-0.04,0.22-0.13,0.3
			c-0.08,0.08-0.18,0.13-0.3,0.13h-0.65c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.09-0.13-0.19-0.13-0.3v-4.47H94.2v4.47
			c0,0.12-0.04,0.22-0.13,0.3c-0.09,0.08-0.19,0.13-0.3,0.13h-0.65c-0.12,0-0.21-0.04-0.3-0.12c-0.08-0.08-0.13-0.18-0.13-0.31
			V44.91c0-0.12,0.04-0.22,0.13-0.3c0.09-0.09,0.19-0.13,0.3-0.13h0.65c0.12,0,0.22,0.04,0.3,0.13c0.08,0.08,0.13,0.19,0.13,0.3
			v4.35h5.58v-4.35c0-0.12,0.04-0.22,0.13-0.3c0.09-0.09,0.19-0.13,0.3-0.13H100.86z"
        ></path>
        <path
          className="st0"
          d="M105.15,53.66c0.12,0,0.22,0.04,0.3,0.13c0.09,0.08,0.13,0.19,0.13,0.3v1.06c0,0.11-0.04,0.21-0.13,0.3
			c-0.08,0.08-0.18,0.13-0.3,0.13h-1.06c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.19-0.13-0.3v-1.06c0-0.12,0.04-0.22,0.13-0.3
			c0.09-0.08,0.18-0.13,0.3-0.13H105.15z"
        ></path>
        <path
          className="st0"
          d="M117.08,53.08h-5.5l-0.82,2.11c-0.03,0.08-0.09,0.17-0.17,0.26c-0.09,0.09-0.23,0.14-0.44,0.14h-0.59
			c-0.1,0-0.18-0.03-0.25-0.1c-0.07-0.07-0.1-0.15-0.1-0.25c0-0.05,0.02-0.13,0.06-0.22L113.15,45c0.05-0.12,0.13-0.23,0.24-0.35
			c0.11-0.12,0.26-0.17,0.48-0.17h0.95c0.21,0,0.37,0.06,0.48,0.17c0.11,0.12,0.18,0.23,0.24,0.35l3.87,10.01
			c0.04,0.1,0.06,0.17,0.06,0.22c0,0.09-0.03,0.18-0.1,0.25c-0.07,0.07-0.15,0.1-0.25,0.1h-0.59c-0.21,0-0.36-0.05-0.44-0.14
			c-0.08-0.09-0.14-0.18-0.17-0.26L117.08,53.08z M112.13,51.65h4.4l-2.19-5.66L112.13,51.65z"
        ></path>
        <path
          className="st0"
          d="M122.22,53.66c0.12,0,0.22,0.04,0.3,0.13c0.09,0.08,0.13,0.19,0.13,0.3v1.06c0,0.11-0.04,0.21-0.13,0.3
			c-0.08,0.08-0.18,0.13-0.3,0.13h-1.06c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.09-0.13-0.19-0.13-0.3v-1.06c0-0.12,0.04-0.22,0.13-0.3
			c0.09-0.08,0.18-0.13,0.3-0.13H122.22z"
        ></path>
        <path
          className="st0"
          d="M137.05,44.48c0.12,0,0.22,0.04,0.3,0.13c0.09,0.08,0.13,0.19,0.13,0.3v10.25c0,0.12-0.04,0.22-0.13,0.3
			c-0.08,0.08-0.18,0.13-0.3,0.13h-0.65c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.09-0.13-0.19-0.13-0.3v-4.47h-5.58v4.47
			c0,0.12-0.04,0.22-0.13,0.3c-0.09,0.08-0.19,0.13-0.3,0.13h-0.65c-0.12,0-0.21-0.04-0.3-0.12c-0.08-0.08-0.13-0.18-0.13-0.31
			V44.91c0-0.12,0.04-0.22,0.13-0.3c0.09-0.09,0.19-0.13,0.3-0.13h0.65c0.12,0,0.22,0.04,0.3,0.13c0.08,0.08,0.13,0.19,0.13,0.3
			v4.35h5.58v-4.35c0-0.12,0.04-0.22,0.13-0.3c0.09-0.09,0.19-0.13,0.3-0.13H137.05z"
        ></path>
        <path
          className="st0"
          d="M139.65,50.67c0.04-0.49,0.16-0.94,0.35-1.36c0.19-0.42,0.44-0.79,0.74-1.11c0.31-0.32,0.68-0.57,1.1-0.75
			c0.43-0.18,0.91-0.27,1.44-0.27c0.57,0,1.08,0.09,1.53,0.28c0.45,0.18,0.83,0.45,1.15,0.8c0.32,0.35,0.56,0.77,0.73,1.27
			c0.17,0.5,0.25,1.05,0.25,1.67v0.43c0,0.12-0.04,0.22-0.13,0.3c-0.09,0.09-0.19,0.13-0.3,0.13h-5.46v0.09
			c0.02,0.72,0.24,1.27,0.66,1.66c0.42,0.38,0.94,0.58,1.56,0.58c0.58,0,1.02-0.08,1.31-0.25c0.29-0.16,0.53-0.35,0.71-0.55
			c0.08-0.08,0.16-0.14,0.22-0.17c0.06-0.03,0.16-0.05,0.29-0.05h0.47c0.12,0,0.22,0.04,0.32,0.13c0.1,0.09,0.13,0.19,0.11,0.3
			c-0.03,0.19-0.12,0.4-0.27,0.63c-0.15,0.23-0.36,0.44-0.64,0.63c-0.28,0.2-0.63,0.36-1.05,0.49c-0.42,0.13-0.91,0.2-1.47,0.2
			c-0.53,0-1.01-0.09-1.43-0.28c-0.43-0.18-0.79-0.44-1.1-0.76c-0.31-0.32-0.56-0.7-0.75-1.14c-0.19-0.44-0.31-0.92-0.35-1.44
			C139.6,51.64,139.6,51.15,139.65,50.67 M141.06,50.71h4.46v-0.05c0-0.64-0.2-1.16-0.61-1.55c-0.41-0.39-0.95-0.58-1.63-0.58
			c-0.31,0-0.59,0.05-0.86,0.15c-0.26,0.1-0.5,0.24-0.7,0.43c-0.2,0.19-0.36,0.41-0.47,0.67c-0.12,0.26-0.18,0.55-0.19,0.87V50.71z"
        ></path>
        <path
          className="st0"
          d="M150.31,50.51l3.3-2.9c0.06-0.05,0.15-0.11,0.25-0.17c0.1-0.06,0.22-0.1,0.37-0.1h0.76
			c0.11,0,0.2,0.04,0.27,0.11c0.07,0.07,0.11,0.16,0.11,0.27c0,0.05-0.01,0.1-0.02,0.15c-0.02,0.05-0.07,0.1-0.15,0.17l-3.84,3.36
			l4.22,3.51c0.11,0.09,0.16,0.18,0.16,0.3c0,0.11-0.04,0.2-0.11,0.27c-0.07,0.07-0.16,0.11-0.27,0.11h-0.82
			c-0.16,0-0.29-0.03-0.4-0.09c-0.11-0.06-0.19-0.12-0.25-0.17l-3.57-2.97v2.81c0,0.12-0.04,0.22-0.13,0.3
			c-0.09,0.09-0.19,0.13-0.3,0.13h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.09-0.08-0.13-0.18-0.13-0.3v-7.39c0-0.12,0.04-0.22,0.13-0.3
			c0.08-0.08,0.18-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13c0.08,0.09,0.13,0.19,0.13,0.3V50.51z"
        ></path>
        <path
          className="st0"
          d="M161.05,55.74c-0.66,0-1.18-0.11-1.57-0.34c-0.39-0.23-0.69-0.47-0.89-0.74v3.51c0,0.12-0.04,0.22-0.13,0.3
			c-0.09,0.08-0.19,0.13-0.3,0.13h-0.59c-0.11,0-0.22-0.04-0.3-0.13c-0.08-0.08-0.13-0.18-0.13-0.3v-10.4c0-0.12,0.04-0.22,0.13-0.3
			c0.09-0.08,0.19-0.13,0.3-0.13h0.59c0.12,0,0.22,0.04,0.3,0.13c0.09,0.09,0.13,0.19,0.13,0.3v0.49c0.21-0.29,0.51-0.54,0.9-0.75
			c0.39-0.22,0.91-0.33,1.55-0.33c0.5,0,0.96,0.09,1.39,0.26c0.43,0.17,0.8,0.43,1.12,0.75c0.32,0.33,0.57,0.72,0.76,1.19
			c0.19,0.47,0.3,0.99,0.33,1.57c0.01,0.16,0.02,0.33,0.02,0.51c0,0.19-0.01,0.36-0.02,0.52c-0.03,0.58-0.14,1.1-0.33,1.57
			c-0.19,0.47-0.44,0.86-0.76,1.18c-0.32,0.32-0.69,0.57-1.12,0.75C162.01,55.65,161.55,55.74,161.05,55.74 M158.59,50.78
			c-0.01,0.16-0.02,0.37-0.02,0.63c0,0.26,0,0.47,0.02,0.63c0.03,0.75,0.25,1.33,0.67,1.74c0.42,0.41,0.96,0.61,1.62,0.61
			c0.7,0,1.25-0.22,1.65-0.67c0.4-0.44,0.62-1.05,0.66-1.81c0.01-0.3,0.01-0.59,0-0.89c-0.04-0.76-0.26-1.36-0.66-1.81
			c-0.4-0.44-0.95-0.67-1.65-0.67c-0.66,0-1.19,0.2-1.62,0.6C158.85,49.54,158.62,50.09,158.59,50.78"
        ></path>
        <path
          className="st0"
          d="M166.04,53.5c0-0.42,0.09-0.79,0.26-1.11c0.17-0.32,0.4-0.59,0.7-0.81c0.3-0.22,0.64-0.4,1.04-0.54
			c0.4-0.14,0.81-0.24,1.26-0.32l2.24-0.36v-0.21c0-0.54-0.18-0.94-0.53-1.21c-0.35-0.27-0.79-0.4-1.32-0.4
			c-0.47,0-0.82,0.08-1.06,0.25c-0.24,0.17-0.44,0.37-0.61,0.6c-0.06,0.09-0.13,0.14-0.21,0.17c-0.08,0.03-0.17,0.05-0.3,0.05h-0.48
			c-0.12,0-0.22-0.04-0.31-0.13c-0.09-0.08-0.13-0.18-0.12-0.3c0.02-0.23,0.11-0.47,0.28-0.71c0.16-0.24,0.39-0.46,0.67-0.65
			c0.28-0.19,0.6-0.35,0.97-0.47c0.36-0.12,0.75-0.18,1.17-0.18c0.48,0,0.92,0.07,1.32,0.21c0.41,0.14,0.76,0.34,1.05,0.6
			c0.29,0.26,0.52,0.59,0.68,0.98c0.16,0.39,0.25,0.84,0.25,1.35v4.84c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.09-0.18,0.13-0.3,0.13
			h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.08-0.13-0.19-0.13-0.3V54.5c-0.1,0.2-0.24,0.38-0.44,0.53
			c-0.2,0.15-0.43,0.28-0.69,0.39c-0.26,0.11-0.53,0.18-0.81,0.24c-0.28,0.05-0.54,0.08-0.79,0.08c-0.41,0-0.79-0.06-1.13-0.17
			c-0.34-0.12-0.64-0.27-0.87-0.47c-0.24-0.2-0.42-0.43-0.55-0.7C166.11,54.12,166.04,53.82,166.04,53.5 M168.96,54.38
			c0.38,0,0.73-0.06,1.05-0.17c0.32-0.11,0.59-0.28,0.82-0.48c0.23-0.21,0.4-0.45,0.52-0.74c0.12-0.28,0.18-0.6,0.18-0.95v-0.4
			l-1.87,0.3c-0.67,0.11-1.19,0.28-1.59,0.51c-0.39,0.23-0.59,0.53-0.59,0.9c0,0.12,0.03,0.23,0.08,0.35
			c0.05,0.12,0.14,0.23,0.26,0.33c0.12,0.11,0.27,0.19,0.45,0.25C168.46,54.35,168.69,54.38,168.96,54.38"
        ></path>
        <path
          className="st0"
          d="M176.36,52.01c0.04,0.42,0.13,0.78,0.28,1.08c0.14,0.3,0.32,0.54,0.53,0.73c0.21,0.19,0.43,0.33,0.69,0.42
			c0.25,0.09,0.51,0.13,0.78,0.13c0.51,0,0.94-0.1,1.3-0.29c0.36-0.19,0.64-0.51,0.84-0.95c0.07-0.17,0.15-0.28,0.23-0.34
			c0.08-0.06,0.18-0.09,0.29-0.09h0.48c0.12,0,0.22,0.04,0.31,0.13c0.09,0.09,0.13,0.19,0.12,0.3c-0.01,0.25-0.09,0.53-0.25,0.83
			c-0.15,0.3-0.38,0.58-0.68,0.84c-0.3,0.26-0.67,0.48-1.11,0.66c-0.44,0.18-0.95,0.27-1.53,0.27c-0.58,0-1.1-0.09-1.55-0.28
			c-0.45-0.19-0.83-0.45-1.14-0.78c-0.31-0.33-0.56-0.71-0.73-1.16c-0.17-0.44-0.27-0.92-0.29-1.43c-0.01-0.17-0.02-0.38-0.02-0.63
			c-0.01-0.25,0-0.46,0.02-0.64c0.04-0.51,0.15-0.98,0.33-1.43c0.17-0.44,0.42-0.83,0.72-1.16c0.31-0.33,0.68-0.59,1.13-0.78
			c0.44-0.19,0.96-0.29,1.54-0.29c0.58,0,1.09,0.09,1.53,0.27c0.44,0.18,0.81,0.4,1.11,0.66c0.3,0.26,0.53,0.54,0.68,0.84
			c0.15,0.3,0.23,0.58,0.25,0.83c0.01,0.12-0.03,0.22-0.12,0.3c-0.09,0.08-0.19,0.13-0.31,0.13h-0.48c-0.12,0-0.21-0.03-0.29-0.09
			c-0.08-0.06-0.16-0.17-0.23-0.34c-0.2-0.44-0.48-0.76-0.84-0.95c-0.36-0.19-0.79-0.29-1.3-0.29c-0.26,0-0.53,0.05-0.79,0.13
			c-0.26,0.09-0.49,0.23-0.7,0.42c-0.21,0.19-0.38,0.43-0.52,0.73c-0.14,0.3-0.23,0.66-0.26,1.08
			C176.32,51.3,176.32,51.67,176.36,52.01"
        ></path>
        <path
          className="st0"
          d="M187.47,47.18c0.57,0,1.08,0.09,1.52,0.26c0.44,0.17,0.82,0.42,1.14,0.72c0.32,0.31,0.57,0.68,0.75,1.12
			c0.18,0.44,0.3,0.92,0.34,1.44c0.01,0.09,0.02,0.21,0.02,0.34v0.41v0.41c0,0.13-0.01,0.24-0.02,0.32
			c-0.05,0.53-0.17,1.01-0.35,1.44c-0.18,0.43-0.43,0.8-0.74,1.11c-0.32,0.31-0.7,0.55-1.14,0.72c-0.44,0.17-0.95,0.26-1.52,0.26
			s-1.08-0.09-1.52-0.26c-0.44-0.17-0.82-0.42-1.14-0.72c-0.32-0.31-0.57-0.68-0.75-1.11c-0.19-0.43-0.3-0.91-0.34-1.44
			c-0.01-0.09-0.02-0.19-0.02-0.32c-0.01-0.13-0.01-0.27-0.01-0.41c0-0.14,0-0.28,0.01-0.41c0-0.13,0.01-0.25,0.02-0.34
			c0.04-0.52,0.15-1,0.34-1.44c0.18-0.44,0.44-0.81,0.75-1.12c0.32-0.31,0.7-0.55,1.14-0.72C186.39,47.26,186.9,47.18,187.47,47.18
			 M189.79,52.12c0.02-0.18,0.03-0.4,0.03-0.66c0-0.26-0.01-0.48-0.03-0.67c-0.03-0.32-0.1-0.61-0.21-0.89
			c-0.11-0.27-0.25-0.51-0.44-0.71c-0.19-0.2-0.42-0.36-0.7-0.48c-0.28-0.12-0.6-0.17-0.97-0.17c-0.37,0-0.69,0.06-0.97,0.17
			c-0.27,0.12-0.51,0.28-0.7,0.48c-0.19,0.2-0.34,0.44-0.44,0.71c-0.11,0.28-0.17,0.57-0.21,0.89c-0.02,0.19-0.03,0.41-0.03,0.67
			c0,0.26,0.01,0.48,0.03,0.66c0.03,0.32,0.1,0.61,0.21,0.89c0.11,0.28,0.25,0.51,0.44,0.71c0.19,0.2,0.42,0.36,0.7,0.48
			c0.28,0.12,0.6,0.17,0.97,0.17c0.37,0,0.69-0.06,0.97-0.17c0.28-0.12,0.51-0.28,0.7-0.48c0.19-0.2,0.34-0.44,0.44-0.71
			C189.69,52.74,189.76,52.44,189.79,52.12"
        ></path>
        <path
          className="st0"
          d="M193.56,55.58c-0.09,0-0.16-0.03-0.22-0.1c-0.06-0.06-0.09-0.14-0.09-0.22v-7.61c0-0.09,0.03-0.16,0.09-0.22
			c0.06-0.06,0.14-0.1,0.22-0.1h3.93c0.91,0,1.62,0.2,2.13,0.6c0.51,0.4,0.76,0.94,0.76,1.6c0,0.24-0.03,0.45-0.09,0.63
			c-0.06,0.18-0.13,0.34-0.22,0.48c-0.09,0.14-0.19,0.26-0.3,0.36c-0.11,0.11-0.22,0.2-0.34,0.29c0.43,0.24,0.73,0.52,0.89,0.84
			c0.16,0.32,0.24,0.68,0.24,1.09c0,0.76-0.26,1.34-0.79,1.74c-0.52,0.4-1.22,0.6-2.1,0.6H193.56z M194.69,48.71v2.02h2.6
			c0.53,0,0.94-0.07,1.22-0.21c0.29-0.14,0.43-0.41,0.43-0.82s-0.16-0.67-0.47-0.79c-0.31-0.13-0.73-0.19-1.26-0.19H194.69z
			 M194.69,52.11v2.09h2.68c0.53,0,0.95-0.08,1.27-0.23c0.32-0.15,0.48-0.43,0.48-0.83s-0.15-0.67-0.45-0.82
			c-0.3-0.14-0.72-0.21-1.24-0.21H194.69z"
        ></path>
        <path
          className="st0"
          d="M201.99,53.5c0-0.42,0.09-0.79,0.25-1.11c0.17-0.32,0.4-0.59,0.7-0.81c0.3-0.22,0.64-0.4,1.04-0.54
			c0.4-0.14,0.82-0.24,1.26-0.32l2.24-0.36v-0.21c0-0.54-0.18-0.94-0.53-1.21c-0.35-0.27-0.79-0.4-1.32-0.4
			c-0.47,0-0.82,0.08-1.06,0.25c-0.24,0.17-0.44,0.37-0.61,0.6c-0.06,0.09-0.13,0.14-0.21,0.17c-0.07,0.03-0.17,0.05-0.3,0.05h-0.48
			c-0.12,0-0.22-0.04-0.31-0.13c-0.09-0.08-0.13-0.18-0.12-0.3c0.02-0.23,0.11-0.47,0.28-0.71c0.16-0.24,0.39-0.46,0.67-0.65
			s0.6-0.35,0.97-0.47c0.36-0.12,0.75-0.18,1.17-0.18c0.48,0,0.92,0.07,1.32,0.21c0.41,0.14,0.76,0.34,1.05,0.6
			c0.29,0.26,0.52,0.59,0.68,0.98c0.16,0.39,0.25,0.84,0.25,1.35v4.84c0,0.12-0.04,0.22-0.13,0.3c-0.08,0.09-0.18,0.13-0.3,0.13
			h-0.59c-0.12,0-0.22-0.04-0.3-0.13c-0.08-0.08-0.13-0.19-0.13-0.3V54.5c-0.1,0.2-0.24,0.38-0.44,0.53
			c-0.2,0.15-0.43,0.28-0.69,0.39c-0.26,0.11-0.53,0.18-0.81,0.24c-0.28,0.05-0.54,0.08-0.79,0.08c-0.41,0-0.79-0.06-1.13-0.17
			c-0.34-0.12-0.64-0.27-0.87-0.47c-0.24-0.2-0.42-0.43-0.55-0.7C202.05,54.12,201.99,53.82,201.99,53.5 M204.91,54.38
			c0.38,0,0.73-0.06,1.05-0.17c0.32-0.11,0.59-0.28,0.82-0.48c0.23-0.21,0.4-0.45,0.52-0.74c0.12-0.28,0.18-0.6,0.18-0.95v-0.4
			l-1.87,0.3c-0.67,0.11-1.19,0.28-1.59,0.51c-0.39,0.23-0.59,0.53-0.59,0.9c0,0.12,0.03,0.23,0.08,0.35
			c0.05,0.12,0.14,0.23,0.26,0.33c0.12,0.11,0.27,0.19,0.45,0.25C204.4,54.35,204.63,54.38,204.91,54.38"
        ></path>
      </g>
    </g>
    <g id="Layer_2"></g>
    <g id="Layer_3"></g>
    <g id="Layer_5"></g>
    <g id="Layer_6"></g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/LogoFooterText/index.js